'use client';

import {
  useQueryState,
  parseAsString,
  parseAsArrayOf,
  type UseQueryStateReturn,
} from 'nuqs';

export function useTopicQuery(
  key = 'topics',
): UseQueryStateReturn<string[], undefined> {
  return useQueryState(key, {
    parse: parseAsArrayOf(parseAsString).withDefault([]).parse,
  });
}
